import { createSlice } from "@reduxjs/toolkit";
import { getInquiryList } from "./thunk";

export interface IState {
  inquiries: any;
  isInquiryLoading: boolean;
  isInquirySuccess: boolean;

  error: any;
}

export const initialState: IState = {
  inquiries: null,
  isInquiryLoading: false,
  isInquirySuccess: false,

  error: {},
};

const AdvertisementSlice = createSlice({
  name: "InquiryList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Advertisements
    builder.addCase(getInquiryList.pending, (state: IState, action: any) => {
      state.isInquiryLoading = true;
    });
    builder.addCase(getInquiryList.fulfilled, (state: IState, action: any) => {
      state.inquiries = action.payload.data;
      state.isInquirySuccess = true;
      state.isInquiryLoading = false;
    });
    builder.addCase(getInquiryList.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isInquirySuccess = false;
      state.isInquiryLoading = false;
    });
  },
});

export default AdvertisementSlice.reducer;
